(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7325],{

/***/ 3010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AddressSearch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/reactgooglemapsapi.esm.js + 3 modules
var reactgooglemapsapi_esm = __webpack_require__(83854);
// EXTERNAL MODULE: ./node_modules/use-places-autocomplete/dist/index.esm.js
var index_esm = __webpack_require__(20906);
// EXTERNAL MODULE: ./styles/modules/AddressSearch.module.scss
var AddressSearch_module = __webpack_require__(25192);
var AddressSearch_module_default = /*#__PURE__*/__webpack_require__.n(AddressSearch_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./helpers/address.js
var parseAddress = function(address) {
    var parsedAddress = {};
    address.address_components.map(function(item) {
        if (item.types[0]) {
            var type = item.types[0];
            if (type === "postal_code") {
                type = "postalCode";
            } else if (type === "postal_town") {
                type = "city";
            }
            parsedAddress[type] = item.long_name;
        }
    });
    var streetNumber = parsedAddress.subpremise || parsedAddress.street_number || "";
    var streetName = parsedAddress.premise || parsedAddress.route || "";
    var street = "";
    if (streetNumber !== "") {
        street += "".concat(streetNumber, " ");
    }
    street += streetName;
    parsedAddress.street = street;
    return parsedAddress;
};


// EXTERNAL MODULE: ./lang/en.json
var en = __webpack_require__(64798);
;// CONCATENATED MODULE: ./components/AddressSearch.js









var googleMapsConfig = {
    googleMapsApiKey: "AIzaSyDP0GVp9O95-FSauY7rXorc_40HG9fjzms",
    language: "en-GB",
    libraries: [
        "places"
    ]
};
function AddressSearch(param) {
    var onUpdate = param.onUpdate, placeholder = param.placeholder, label = param.label, labelAbove = param.labelAbove, register = param.register, name = param.name;
    var ref = (0,reactgooglemapsapi_esm/* useLoadScript */.Db)(googleMapsConfig), isLoaded = ref.isLoaded, loadError = ref.loadError;
    var showElem = /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {
        onUpdate: onUpdate,
        placeholder: placeholder,
        label: label,
        labelAbove: labelAbove,
        register: register,
        name: name
    });
    if (loadError) showElem = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: "Error"
    });
    if (!isLoaded) showElem = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AddressSearch_module_default()).wrapper,
        children: showElem
    });
}
function Search(param) {
    var onUpdate = param.onUpdate, placeholder = param.placeholder, label = param.label, labelAbove = param.labelAbove, register = param.register, name = param.name;
    var ref = (0,index_esm/* default */.ZP)(), value = ref.value, _suggestions = ref.suggestions, status = _suggestions.status, data = _suggestions.data, setValue = ref.setValue, clearSuggestions = ref.clearSuggestions;
    var ref1 = (0,react.useState)(false), showResults = ref1[0], setShowResults = ref1[1];
    var handleInput = function(e) {
        var val = e.target.value;
        setValue(val);
    };
    var handleSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
            var results, parsedAddress, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setValue(item.description, false);
                        clearSuggestions();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,index_esm/* getGeocode */.LM)({
                                address: item.description
                            })
                        ];
                    case 2:
                        results = _state.sent();
                        if (results.length > 0) {
                            parsedAddress = parseAddress(results[0]);
                            parsedAddress.fullAddress = item.description;
                            onUpdate(parsedAddress);
                            setValue("");
                            clearSuggestions();
                            setShowResults(false);
                        } else {
                            alert("error");
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error); // eslint-disable-line
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelect(item) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    (AddressSearch_module_default()).inputWrapper,
                    labelAbove ? (AddressSearch_module_default()).hasLabelAbove : "", 
                ].join(" "),
                children: [
                    labelAbove && label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: (AddressSearch_module_default()).labelAbove,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        name: name,
                        onChange: handleInput,
                        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : en/* profile.header.address.sidebar.search */.N5.Fs.Lk.r.yC,
                        className: [
                            (AddressSearch_module_default()).input,
                            labelAbove ? (AddressSearch_module_default()).hasLabelAbove : "", 
                        ].join(" "),
                        value: value,
                        onFocus: function() {
                            setShowResults(true);
                        },
                        ref: register
                    }),
                    !labelAbove && label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        children: label
                    })
                ]
            }),
            status === "OK" && showResults && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    "border-gray",
                    (AddressSearch_module_default()).results
                ].join(" "),
                children: data.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            return handleSelect(item);
                        },
                        className: (AddressSearch_module_default()).resultsItem,
                        children: item.description
                    }, item.place_id);
                })
            })
        ]
    });
}


/***/ }),

/***/ 38504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styles_modules_Box_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28456);
/* harmony import */ var styles_modules_Box_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Box_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Box = function(props) {
    var data = props.data;
    if (!data) return null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var small = data.small ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
        className: (styles_modules_Box_module_scss__WEBPACK_IMPORTED_MODULE_2___default().small),
        children: data.small
    }) : null;
    var title = data.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
        className: (styles_modules_Box_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
        children: data.title
    }) : null;
    var body = data.body ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (styles_modules_Box_module_scss__WEBPACK_IMPORTED_MODULE_2___default().body),
        dangerouslySetInnerHTML: {
            __html: data.body
        }
    }) : null;
    var cta = data.cta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: (styles_modules_Box_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cta),
        onClick: data.cta.onClick ? data.cta.onClick : function() {
            return router.push(data.cta.href);
        },
        children: data.cta.title
    }) : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            "border-gray",
            (styles_modules_Box_module_scss__WEBPACK_IMPORTED_MODULE_2___default().box),
            (styles_modules_Box_module_scss__WEBPACK_IMPORTED_MODULE_2___default())["box__".concat(data.theme)], 
        ].join(" "),
        onClick: data.boxClick && data.boxClick.onClick,
        children: [
            small,
            title,
            body,
            cta
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Box);


/***/ }),

/***/ 25113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61385);
/* harmony import */ var styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Checkbox = function(param) {
    var name = param.name, label = param.label, register = param.register, initialValue = param.initialValue, onChange = param.onChange, className = param.className, error = param.error, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialValue), checked = ref[0], setChecked = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().checkbox),
            className ? className : ""
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                name: name,
                id: name,
                type: "checkbox",
                disabled: disabled,
                defaultChecked: initialValue,
                checked: register ? undefined : checked,
                onChange: register ? undefined : function(param) {
                    var checked = param.target.checked;
                    setChecked(checked);
                    onChange ? onChange() : null;
                },
                className: (styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().input),
                ref: register ? register : undefined
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: name,
                className: (styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().label),
                children: label
            }),
            (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().error),
                children: error.message
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 84925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_FormWithSidebar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/modules/FormWithSidebar.module.scss
var FormWithSidebar_module = __webpack_require__(70120);
var FormWithSidebar_module_default = /*#__PURE__*/__webpack_require__.n(FormWithSidebar_module);
// EXTERNAL MODULE: ./components/Checkbox.js
var Checkbox = __webpack_require__(25113);
// EXTERNAL MODULE: ./components/Input.js + 1 modules
var Input = __webpack_require__(21105);
// EXTERNAL MODULE: ./components/Button.js + 2 modules
var Button = __webpack_require__(44217);
// EXTERNAL MODULE: ./components/Box.js
var Box = __webpack_require__(38504);
// EXTERNAL MODULE: ./styles/modules/Quote.module.scss
var Quote_module = __webpack_require__(37417);
var Quote_module_default = /*#__PURE__*/__webpack_require__.n(Quote_module);
;// CONCATENATED MODULE: ./components/Quote.js


var Quote = function(param) {
    var quote = param.quote;
    if (!quote) return null;
    var author = null;
    if (quote.author) {
        author = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Quote_module_default()).author,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Quote_module_default()).authorImage
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Quote_module_default()).authorBody,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: quote.author.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                            children: quote.author.sub
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Quote_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                className: (Quote_module_default()).quote,
                children: quote.quote
            }),
            author
        ]
    });
};
/* harmony default export */ var components_Quote = (Quote);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/Svg/Bulb.js

function Bulb(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#ffffff";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.687 1.76a.8.8 0 00-1.6 0v.8a.8.8 0 101.6 0v-.8zM4.252 3.195a.8.8 0 00-1.13 1.131l.8.8a.8.8 0 001.13-1.131l-.8-.8zm10.4 1.131a.8.8 0 00-1.13-1.131l-.8.8a.8.8 0 001.13 1.131l.8-.8zM8.887 4.16a4.8 4.8 0 00-2.654 8.8h5.307a4.8 4.8 0 00-2.653-8.8zm2.4 9.6h-4.8v.8a2.4 2.4 0 104.8 0v-.8zm-9.6-5.6a.8.8 0 100 1.6h.8a.8.8 0 000-1.6h-.8zm13.6 0a.8.8 0 000 1.6h.8a.8.8 0 100-1.6h-.8z",
            fill: fill
        })
    });
}

// EXTERNAL MODULE: ./styles/modules/BoxTopTip.module.scss
var BoxTopTip_module = __webpack_require__(62461);
var BoxTopTip_module_default = /*#__PURE__*/__webpack_require__.n(BoxTopTip_module);
// EXTERNAL MODULE: ./components/Typo.js
var Typo = __webpack_require__(23775);
// EXTERNAL MODULE: ./components/Svg/ArrowDown.js
var ArrowDown = __webpack_require__(87878);
;// CONCATENATED MODULE: ./components/BoxTopTip.js








var BoxTopTip = function(props) {
    var data = props.data;
    if (!data) return null;
    var ref = (0,react.useState)(false), collapsed = ref[0], setCollapse = ref[1];
    var isCollapsable = data.allowCollapse ? true : false;
    var router = (0,next_router.useRouter)();
    var small = data.small ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
        className: (BoxTopTip_module_default()).small,
        children: data.small
    }) : null;
    var title = data.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
        className: (BoxTopTip_module_default()).title,
        dangerouslySetInnerHTML: {
            __html: data.title
        }
    }) : null;
    var priceSection = data.price_description ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: (BoxTopTip_module_default())["price-wrapper"],
        children: [
            (data === null || data === void 0 ? void 0 : data.price) && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                className: (BoxTopTip_module_default())["price-wrapper__price"],
                children: data.price
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                className: (BoxTopTip_module_default())["price-wrapper__description"],
                dangerouslySetInnerHTML: {
                    __html: data.price_description
                }
            })
        ]
    }) : null;
    var bodyImage = data.body_image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: data.body_image
    }) : null;
    var body = data.body ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (BoxTopTip_module_default()).body,
        dangerouslySetInnerHTML: {
            __html: data.body
        }
    }) : null;
    var person = data.person ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (BoxTopTip_module_default())["box-toptip__person"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (BoxTopTip_module_default())["box-toptip__person-image"],
                src: data.person.avatar
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BoxTopTip_module_default())["box-toptip__person-info"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                        variant: "h4",
                        children: data.person.fullname
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                        children: data.person.position
                    })
                ]
            })
        ]
    }) : null;
    var cta = data.cta ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        theme: "primary",
        title: data.cta.title,
        onClick: data.cta.onClick,
        loading: data.cta.loading
    }) : null;
    var toggleCollapse = function() {
        return collapsed === true ? setCollapse(false) : setCollapse(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (BoxTopTip_module_default())["box-toptip"],
            (BoxTopTip_module_default())["box-toptip--".concat(data.theme)],
            isCollapsable === true ? (BoxTopTip_module_default())["box-toptip--collapsable"] : null,
            collapsed === true ? (BoxTopTip_module_default())["box-toptip--collapsable-is-open"] : null, 
        ].join(" "),
        children: [
            data.icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (BoxTopTip_module_default())["box-toptip__icon"],
                children: (data === null || data === void 0 ? void 0 : data.icon) && data.icon.variant === "small" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (BoxTopTip_module_default())["box-toptip__icon-inside"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bulb, {})
                        }),
                        small
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BoxTopTip_module_default())["box-toptip__icon-inside--big"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: data.icon.src
                        })
                    })
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BoxTopTip_module_default())["box-toptip__body-wrapper"],
                children: [
                    isCollapsable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BoxTopTip_module_default())["box-toptip__small--mobile"],
                        children: small
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BoxTopTip_module_default())["box-toptip__headline"],
                        onClick: function() {
                            if (isCollapsable === true) {
                                toggleCollapse();
                            }
                        },
                        children: [
                            title,
                            isCollapsable && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#",
                                className: [
                                    (BoxTopTip_module_default())["box-toptip__collapse-button"], 
                                ].join(" "),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BoxTopTip_module_default())["box-toptip__body-wrap"],
                        children: [
                            bodyImage,
                            body,
                            person,
                            cta,
                            priceSection
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_BoxTopTip = (BoxTopTip);

// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./components/AddressSearch.js + 1 modules
var AddressSearch = __webpack_require__(3010);
;// CONCATENATED MODULE: ./components/FormWithSidebar.js

















var FormWithSidebar = function(props) {
    var router = (0,next_router.useRouter)();
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var data = props.data;
    var form = data.form, sidebar = data.sidebar, errors = data.errors, controls = data.controls;
    var reCaptchaOnSubmitProxy = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref, ref1, token;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!executeRecaptcha) {
                            console.log("Execute recaptcha not yet available");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            executeRecaptcha()
                        ];
                    case 1:
                        token = _state.sent();
                        form === null || form === void 0 ? void 0 : (ref = form.setValue) === null || ref === void 0 ? void 0 : ref.call(form, "captchaToken", token);
                        form === null || form === void 0 ? void 0 : (ref1 = form.onSubmit) === null || ref1 === void 0 ? void 0 : ref1.call(form);
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        executeRecaptcha,
        form === null || form === void 0 ? void 0 : form.id,
        form === null || form === void 0 ? void 0 : form.onSubmit,
        form === null || form === void 0 ? void 0 : form.setValue
    ]);
    if (!data) return null;
    // todo: refactor this Button - no 'data'
    var inputs = data.form.inputs.map(function(item, key) {
        if (item.component === "button") {
            return /*#__PURE__*/ (0,react.createElement)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                key: "formWithSidebar-".concat(key),
                loading: data.form.loading,
                theme: "secondary"
            }));
        } else if (item.component === "checkbox") {
            return /*#__PURE__*/ (0,react.createElement)(Checkbox/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                className: (FormWithSidebar_module_default()).checkbox,
                key: "formWithSidebar-".concat(key)
            }));
        } else if (item.name === "fullAddress") {
            return /*#__PURE__*/ (0,react.createElement)(AddressSearch/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                key: "formWithSidebar-".concat(key)
            }));
        } else {
            return /*#__PURE__*/ (0,react.createElement)(Input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                key: "formWithSidebar-".concat(key)
            }));
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FormWithSidebar_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    width: "100%"
                },
                children: [
                    form.controls && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FormWithSidebar_module_default()).controls,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/register/profile",
                                className: router.pathname == "/register/profile" ? [
                                    (FormWithSidebar_module_default()).controls__item,
                                    (FormWithSidebar_module_default())["controls__item--active"], 
                                ].join(" ") : (FormWithSidebar_module_default()).controls__item,
                                children: "Newspager"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/register/journalist",
                                className: router.pathname == "/register/journalist" ? [
                                    (FormWithSidebar_module_default()).controls__item,
                                    (FormWithSidebar_module_default())["controls__item--active"], 
                                ].join(" ") : (FormWithSidebar_module_default()).controls__item,
                                children: "Journalist"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: [
                            "border-accent",
                            (FormWithSidebar_module_default()).body
                        ].join(" "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                dangerouslySetInnerHTML: {
                                    __html: form.title
                                }
                            }),
                            form.walkthrough && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (FormWithSidebar_module_default()).walkthrough,
                                children: form.walkthrough
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (FormWithSidebar_module_default()).bodyWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (FormWithSidebar_module_default()).bodyForm,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                            method: "post",
                                            onSubmit: reCaptchaOnSubmitProxy,
                                            children: inputs
                                        }),
                                        form.helper && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (FormWithSidebar_module_default()).helper,
                                            children: form.helper
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FormWithSidebar_module_default()).sidebar,
                children: [
                    (sidebar === null || sidebar === void 0 ? void 0 : sidebar.topTips) && sidebar.topTips.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BoxTopTip, {
                            data: item
                        }, index);
                    }),
                    (sidebar === null || sidebar === void 0 ? void 0 : sidebar.box) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        data: sidebar.box
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FormWithSidebar_module_default()).sidebarQuote,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Quote, {
                            quote: sidebar.quote
                        })
                    })
                ]
            })
        ]
    });
};
var RecaptchaWrapper = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
        reCaptchaKey: "6Lc2t9EiAAAAAH2646UgmZyx4Sg0jMmuSVpvkCul",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormWithSidebar, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var components_FormWithSidebar = (RecaptchaWrapper);


/***/ }),

/***/ 21105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Input; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/modules/Input.module.scss
var Input_module = __webpack_require__(47909);
var Input_module_default = /*#__PURE__*/__webpack_require__.n(Input_module);
;// CONCATENATED MODULE: ./components/Svg/Eye.js

function Eye(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#212121";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1418 916",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: fill,
                d: "M708.531 676.277c120.483 0 218.154-97.671 218.154-218.154 0-120.483-97.671-218.154-218.154-218.154-120.483 0-218.154 97.671-218.154 218.154 0 120.483 97.671 218.154 218.154 218.154z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: fill,
                d: "M1395.29 397.695C1227.6 195.057 973.767 0 708.516 0 443.214 0 189.318 195.193 21.7404 397.695c-28.9872 35.013-28.9872 85.843 0 120.857 42.131 50.911 130.4556 149.19 248.4226 235.061 297.096 216.277 578.956 216.755 876.707 0 117.97-85.871 206.29-184.15 248.42-235.061 28.9-34.946 29.05-85.729 0-120.857zM708.516 152.708c168.415 0 305.414 137 305.414 305.415 0 168.415-136.999 305.416-305.414 305.416S403.101 626.538 403.101 458.123s137-305.415 305.415-305.415z"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Input.js





var Input = function(param) {
    var value = param.value, type = param.type, onFocus = param.onFocus, onBlur = param.onBlur, onChange = param.onChange, onKeyUp = param.onKeyUp, placeholder = param.placeholder, label = param.label, name = param.name, disabled = param.disabled, color = param.color, error = param.error, register = param.register, _classes = param.classes, classes = _classes === void 0 ? [] : _classes, labelAbove = param.labelAbove, autoComplete = param.autoComplete;
    var ref = (0,react.useState)(type || "text"), inputType = ref[0], setInputType = ref[1];
    var ref1 = (0,react.useState)(false), active = ref1[0], setActive = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        var inputValue = (ref = document.getElementById(name)) === null || ref === void 0 ? void 0 : ref.value;
        if (value && value.trim() !== "" || inputValue && inputValue.trim() !== "") setActive(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (Input_module_default()).inputWrapper,
            (Input_module_default())["inputWrapper".concat(color)],
            error ? (Input_module_default()).inputWrapperError : null,
            labelAbove ? (Input_module_default()).hasLabelAbove : "", 
        ].join(" "),
        children: [
            labelAbove && label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (Input_module_default()).labelAbove,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: name,
                name: name,
                type: inputType,
                className: [
                    (Input_module_default()).input,
                    active ? (Input_module_default()).inputActive : null, 
                ].concat((0,_to_consumable_array/* default */.Z)(classes), [
                    error ? (Input_module_default()).error : "",
                    labelAbove ? (Input_module_default()).hasLabelAbove : "", 
                ]).join(" "),
                onFocus: function(event) {
                    setActive(true);
                    onFocus ? onFocus(event) : null;
                },
                onBlur: function(event) {
                    event.target.value ? null : setActive(false);
                    onBlur ? onBlur(event) : null;
                },
                onChange: function(event) {
                    setActive(true);
                    onChange ? onChange(event) : null;
                },
                onKeyUp: onKeyUp ? function(param) {
                    var value = param.target.value;
                    return onKeyUp(name, value.trim());
                } : null,
                ref: register,
                placeholder: placeholder,
                defaultValue: value,
                disabled: disabled,
                autoComplete: autoComplete
            }),
            !labelAbove && label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: name,
                children: label
            }),
            type === "password" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Input_module_default()).password,
                onClick: function() {
                    return inputType === "password" ? setInputType("text") : setInputType("password");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Eye, {})
            }),
            (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Input_module_default()).error,
                children: error.message
            })
        ]
    });
};
/* harmony default export */ var components_Input = (Input);


/***/ }),

/***/ 87878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowDown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function ArrowDown() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1 5l5 5 5-5",
            stroke: "var(--color-blue)",
            strokeWidth: "2"
        })
    });
}


/***/ }),

/***/ 23775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61176);
/* harmony import */ var styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1__);




var Typo = function(props) {
    var variant = props.variant, Tag = props.Tag, color = props.color, className = props.className, children = props.children, font = props.font;
    if (!Tag) {
        switch(variant){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
            case "blockquote":
                Tag = variant;
                break;
            default:
                Tag = "p";
        }
    }
    if (!variant) variant = "body";
    var classes = [
        (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default().typo),
        variant ? (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["typo--".concat(variant)] : null,
        color ? (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["typo--".concat(color)] : null,
        font ? (styles_modules_Typo_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["typo--".concat(font)] : null,
        className ? className : null, 
    ].filter(Boolean).join(" ");
    var modifiedProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        className: classes
    });
    // Remove props so they don't appear in DOM
    delete modifiedProps.variant;
    delete modifiedProps.Tag;
    delete modifiedProps.font;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, modifiedProps), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Typo);


/***/ }),

/***/ 25192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"AddressSearch_input__VIjjH","wrapper":"AddressSearch_wrapper__KTKaJ","inputWrapper":"AddressSearch_inputWrapper__WY5pB","hasLabelAbove":"AddressSearch_hasLabelAbove__eGjbA","inputActive":"AddressSearch_inputActive__nfF7c","results":"AddressSearch_results__1NJ8i","resultsItem":"AddressSearch_resultsItem__EAfcr"};

/***/ }),

/***/ 28456:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box___iC4s","box__blue":"Box_box__blue__60Xb1","cta":"Box_cta__OlJbH","box__dark-gray":"Box_box__dark-gray__t88RZ","small":"Box_small__3mMSm","title":"Box_title__9b22y","body":"Box_body__yes4j"};

/***/ }),

/***/ 62461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box-toptip":"BoxTopTip_box-toptip__uEOd7","box-toptip--withButton":"BoxTopTip_box-toptip--withButton__9atpd","box-toptip__small--mobile":"BoxTopTip_box-toptip__small--mobile__cSmy7","title":"BoxTopTip_title__4DBnd","body":"BoxTopTip_body__I8me3","button":"BoxTopTip_button__917qK","box-toptip__body-wrapper":"BoxTopTip_box-toptip__body-wrapper__19SEp","box-toptip__headline":"BoxTopTip_box-toptip__headline__Dd9G6","box-toptip--withButton-2":"BoxTopTip_box-toptip--withButton-2___Zbbd","box-toptip__body-wrap":"BoxTopTip_box-toptip__body-wrap__O0OPb","box-toptip--collapsable":"BoxTopTip_box-toptip--collapsable__s0b17","box-toptip__icon":"BoxTopTip_box-toptip__icon__fGmJN","box-toptip--collapsable__body-wrapper":"BoxTopTip_box-toptip--collapsable__body-wrapper__di_Sg","box-toptip__collapse-button":"BoxTopTip_box-toptip__collapse-button__zD4k4","box-toptip__person":"BoxTopTip_box-toptip__person__F4oZN","box-toptip__person-info":"BoxTopTip_box-toptip__person-info__MpPnh","box-toptip__person-image":"BoxTopTip_box-toptip__person-image__BKj0q","box-toptip__icon-inside":"BoxTopTip_box-toptip__icon-inside__s_XY_","box-toptip__icon-inside--big":"BoxTopTip_box-toptip__icon-inside--big__eXaVT","box-toptip--collapsable-is-open":"BoxTopTip_box-toptip--collapsable-is-open__DuiWv","price-wrapper":"BoxTopTip_price-wrapper__VLo2A","small":"BoxTopTip_small__GIgWJ","price-wrapper__price":"BoxTopTip_price-wrapper__price__bXaAE","price-wrapper__description":"BoxTopTip_price-wrapper__description__Ab44T","cta":"BoxTopTip_cta__g7gd3","box-toptip__blue":"BoxTopTip_box-toptip__blue__NTWva","box-toptip__dark-gray":"BoxTopTip_box-toptip__dark-gray__KykNz"};

/***/ }),

/***/ 61385:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2Wn0I","input":"Checkbox_input__s0QyL","label":"Checkbox_label__qWLb_","error":"Checkbox_error__haSHE"};

/***/ }),

/***/ 70120:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormWithSidebar_wrapper__HiXGN","controls":"FormWithSidebar_controls__2reLT","controls__item":"FormWithSidebar_controls__item__PdhPS","controls__item--active":"FormWithSidebar_controls__item--active__o4o_B","body":"FormWithSidebar_body__44g6X","walkthrough":"FormWithSidebar_walkthrough__3Zk_p","helper":"FormWithSidebar_helper__nfo2d","bodyWrapper":"FormWithSidebar_bodyWrapper__9tbuy","bodyForm":"FormWithSidebar_bodyForm__3sjBO","sidebar":"FormWithSidebar_sidebar__Vdfvs","sidebarQuote":"FormWithSidebar_sidebarQuote__SuGb9","error":"FormWithSidebar_error__xt9MB","errorInfo":"FormWithSidebar_errorInfo__Q1tct","errorWrapper":"FormWithSidebar_errorWrapper__FyJVq","checkbox":"FormWithSidebar_checkbox__vsVOp"};

/***/ }),

/***/ 37417:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__DPY8N","author":"Quote_author__u1vIO","authorImage":"Quote_authorImage__jGV1f","authorBody":"Quote_authorBody__6VGLl"};

/***/ }),

/***/ 30969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageRegister":"Register_pageRegister__Becit","row":"Register_row__CIXEf","rowVc":"Register_rowVc__GlMFG","rowSb":"Register_rowSb__GVnAk","login":"Register_login__bvZoZ","subscription":"Register_subscription__p4RMU"};

/***/ }),

/***/ 61176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"typo--serif":"Typo_typo--serif__ahG_k","typo--h1":"Typo_typo--h1__k9d1d","typo--h2":"Typo_typo--h2__ERFQP","typo--h3":"Typo_typo--h3__96TzI","typo--h4":"Typo_typo--h4__50rIx","typo--eyebrow":"Typo_typo--eyebrow__ZpogH","typo--perex":"Typo_typo--perex__jtAL0","typo--body":"Typo_typo--body__N8tZg","typo--small":"Typo_typo--small__IMpLY","typo--caption":"Typo_typo--caption__BQ_Ci","typo--special":"Typo_typo--special__PCh7S","typo--quote":"Typo_typo--quote__kbLSb","typo--quote-author":"Typo_typo--quote-author__gGzSj"};

/***/ }),

/***/ 50259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pm": function() { return /* binding */ h; },
/* harmony export */   "xX": function() { return /* binding */ g; }
/* harmony export */ });
/* unused harmony exports GoogleReCaptcha, GoogleReCaptchaConsumer, GoogleReCaptchaContext, withGoogleReCaptcha */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* provided dependency */ var process = __webpack_require__(83454);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */var s=function(){return s=Object.assign||function(e){for(var t,r=1,o=arguments.length;r<o;r++)for(var n in t=arguments[r])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},s.apply(this,arguments)};function u(e,t,r,o){return new(r||(r=Promise))((function(n,a){function c(e){try{s(o.next(e))}catch(e){a(e)}}function i(e){try{s(o.throw(e))}catch(e){a(e)}}function s(e){var t;e.done?n(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(c,i)}s((o=o.apply(e,t||[])).next())}))}function l(e,t){var r,o,n,a,c={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return a={next:i(0),throw:i(1),return:i(2)},"function"==typeof Symbol&&(a[Symbol.iterator]=function(){return this}),a;function i(a){return function(i){return function(a){if(r)throw new TypeError("Generator is already executing.");for(;c;)try{if(r=1,o&&(n=2&a[0]?o.return:a[0]?o.throw||((n=o.return)&&n.call(o),0):o.next)&&!(n=n.call(o,a[1])).done)return n;switch(o=0,n&&(a=[2&a[0],n.value]),a[0]){case 0:case 1:n=a;break;case 4:return c.label++,{value:a[1],done:!1};case 5:c.label++,o=a[1],a=[0];continue;case 7:a=c.ops.pop(),c.trys.pop();continue;default:if(!(n=c.trys,(n=n.length>0&&n[n.length-1])||6!==a[0]&&2!==a[0])){c=0;continue}if(3===a[0]&&(!n||a[1]>n[0]&&a[1]<n[3])){c.label=a[1];break}if(6===a[0]&&c.label<n[1]){c.label=n[1],n=a;break}if(n&&c.label<n[2]){c.label=n[2],c.ops.push(a);break}n[2]&&c.ops.pop(),c.trys.pop();continue}a=t.call(e,c)}catch(e){a=[6,e],o=0}finally{r=n=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,i])}}}var f,p=function(e){var t;e?function(e){if(e)for(;e.lastChild;)e.lastChild.remove()}("string"==typeof e?document.getElementById(e):e):(t=document.querySelector(".grecaptcha-badge"))&&t.parentNode&&document.body.removeChild(t.parentNode)},d=function(e,t){p(t),window.___grecaptcha_cfg=void 0;var r=document.querySelector("#"+e);r&&r.remove(),function(){var e=document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');e&&e.remove()}()},y=function(e){var t=e.render,r=e.onLoadCallbackName,o=e.language,n=e.onLoad,a=e.useRecaptchaNet,c=e.useEnterprise,i=e.scriptProps,s=void 0===i?{}:i,u=s.nonce,l=void 0===u?"":u,f=s.defer,p=void 0!==f&&f,d=s.async,y=void 0!==d&&d,m=s.id,v=void 0===m?"":m,b=s.appendTo,h=v||"google-recaptcha-v3";if(function(e){return!!document.querySelector("#"+e)}(h))n();else{var g=function(e){return"https://www."+(e.useRecaptchaNet?"recaptcha.net":"google.com")+"/recaptcha/"+(e.useEnterprise?"enterprise.js":"api.js")}({useEnterprise:c,useRecaptchaNet:a}),S=document.createElement("script");S.id=h,S.src=g+"?render="+t+("explicit"===t?"&onload="+r:"")+(o?"&hl="+o:""),l&&(S.nonce=l),S.defer=!!p,S.async=!!y,S.onload=n,("body"===b?document.body:document.getElementsByTagName("head")[0]).appendChild(S)}},m=function(e){"undefined"!=typeof process&&!!process.env&&"production"!=="production"||console.warn(e)};!function(e){e.SCRIPT_NOT_AVAILABLE="Recaptcha script is not available"}(f||(f={}));var v=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({executeRecaptcha:function(){throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider")}}),b=v.Consumer;function h(t){var i=t.reCaptchaKey,u=t.useEnterprise,l=void 0!==u&&u,p=t.useRecaptchaNet,b=void 0!==p&&p,h=t.scriptProps,g=t.language,S=t.container,w=t.children,$=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),C=$[0],P=$[1],x=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(i),E=JSON.stringify(h),R=JSON.stringify(null==S?void 0:S.parameters);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((function(){if(i){var e=(null==h?void 0:h.id)||"google-recaptcha-v3",t=(null==h?void 0:h.onLoadCallbackName)||"onRecaptchaLoadCallback";window[t]=function(){var e=l?window.grecaptcha.enterprise:window.grecaptcha,t=s({badge:"inline",size:"invisible",sitekey:i},(null==S?void 0:S.parameters)||{});x.current=e.render(null==S?void 0:S.element,t)};return y({render:(null==S?void 0:S.element)?"explicit":i,onLoadCallbackName:t,useEnterprise:l,useRecaptchaNet:b,scriptProps:h,language:g,onLoad:function(){if(window&&window.grecaptcha){var e=l?window.grecaptcha.enterprise:window.grecaptcha;e.ready((function(){P(e)}))}else m("<GoogleRecaptchaProvider /> "+f.SCRIPT_NOT_AVAILABLE)},onError:function(){m("Error loading google recaptcha script")}}),function(){d(e,null==S?void 0:S.element)}}m("<GoogleReCaptchaProvider /> recaptcha key not provided")}),[l,b,E,R,g,i,null==S?void 0:S.element]);var M=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((function(e){if(!C||!C.execute)throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");return C.execute(x.current,{action:e})}),[C,x]),N=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)((function(){return{executeRecaptcha:C?M:void 0,container:null==S?void 0:S.element}}),[M,C,null==S?void 0:S.element]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(v.Provider,{value:N},w)}var g=function(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(v)};function S(t){var r=this,o=t.action,a=t.onVerify,c=t.refreshReCaptcha,i=g();n((function(){var e=i.executeRecaptcha;if(e){u(r,void 0,void 0,(function(){var t;return l(this,(function(r){switch(r.label){case 0:return[4,e(o)];case 1:return t=r.sent(),a?(a(t),[2]):(m("Please define an onVerify function"),[2])}}))}))}}),[o,a,c,i]);var s=i.container;return"string"==typeof s?e.createElement("div",{id:s}):null}function w(e,t){return e(t={exports:{}},t.exports),t.exports
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */}var $="function"==typeof Symbol&&Symbol.for,C=$?Symbol.for("react.element"):60103,P=$?Symbol.for("react.portal"):60106,x=$?Symbol.for("react.fragment"):60107,E=$?Symbol.for("react.strict_mode"):60108,R=$?Symbol.for("react.profiler"):60114,M=$?Symbol.for("react.provider"):60109,N=$?Symbol.for("react.context"):60110,O=$?Symbol.for("react.async_mode"):60111,_=$?Symbol.for("react.concurrent_mode"):60111,T=$?Symbol.for("react.forward_ref"):60112,j=$?Symbol.for("react.suspense"):60113,L=$?Symbol.for("react.suspense_list"):60120,k=$?Symbol.for("react.memo"):60115,F=$?Symbol.for("react.lazy"):60116,A=$?Symbol.for("react.block"):60121,V=$?Symbol.for("react.fundamental"):60117,z=$?Symbol.for("react.responder"):60118,G=$?Symbol.for("react.scope"):60119;function I(e){if("object"==typeof e&&null!==e){var t=e.$$typeof;switch(t){case C:switch(e=e.type){case O:case _:case x:case R:case E:case j:return e;default:switch(e=e&&e.$$typeof){case N:case T:case F:case k:case M:return e;default:return t}}case P:return t}}}function D(e){return I(e)===_}var q={AsyncMode:O,ConcurrentMode:_,ContextConsumer:N,ContextProvider:M,Element:C,ForwardRef:T,Fragment:x,Lazy:F,Memo:k,Portal:P,Profiler:R,StrictMode:E,Suspense:j,isAsyncMode:function(e){return D(e)||I(e)===O},isConcurrentMode:D,isContextConsumer:function(e){return I(e)===N},isContextProvider:function(e){return I(e)===M},isElement:function(e){return"object"==typeof e&&null!==e&&e.$$typeof===C},isForwardRef:function(e){return I(e)===T},isFragment:function(e){return I(e)===x},isLazy:function(e){return I(e)===F},isMemo:function(e){return I(e)===k},isPortal:function(e){return I(e)===P},isProfiler:function(e){return I(e)===R},isStrictMode:function(e){return I(e)===E},isSuspense:function(e){return I(e)===j},isValidElementType:function(e){return"string"==typeof e||"function"==typeof e||e===x||e===_||e===R||e===E||e===j||e===L||"object"==typeof e&&null!==e&&(e.$$typeof===F||e.$$typeof===k||e.$$typeof===M||e.$$typeof===N||e.$$typeof===T||e.$$typeof===V||e.$$typeof===z||e.$$typeof===G||e.$$typeof===A)},typeOf:I},B=w((function(e,t){ false&&0})),J=(B.AsyncMode,B.ConcurrentMode,B.ContextConsumer,B.ContextProvider,B.Element,B.ForwardRef,B.Fragment,B.Lazy,B.Memo,B.Portal,B.Profiler,B.StrictMode,B.Suspense,B.isAsyncMode,B.isConcurrentMode,B.isContextConsumer,B.isContextProvider,B.isElement,B.isForwardRef,B.isFragment,B.isLazy,B.isMemo,B.isPortal,B.isProfiler,B.isStrictMode,B.isSuspense,B.isValidElementType,B.typeOf,w((function(e){ true?e.exports=q:0}))),K={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},U={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},H={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},Q={};function W(e){return J.isMemo(e)?H:Q[e.$$typeof]||K}Q[J.ForwardRef]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},Q[J.Memo]=H;var X=Object.defineProperty,Y=Object.getOwnPropertyNames,Z=Object.getOwnPropertySymbols,ee=Object.getOwnPropertyDescriptor,te=Object.getPrototypeOf,re=Object.prototype;var oe=function e(t,r,o){if("string"!=typeof r){if(re){var n=te(r);n&&n!==re&&e(t,n,o)}var a=Y(r);Z&&(a=a.concat(Z(r)));for(var c=W(t),i=W(r),s=0;s<a.length;++s){var u=a[s];if(!(U[u]||o&&o[u]||i&&i[u]||c&&c[u])){var l=ee(r,u);try{X(t,u,l)}catch(e){}}}}return t},ne=function(t){var r=function(r){return e.createElement(b,null,(function(o){return e.createElement(t,s({},r,{googleReCaptchaProps:o}))}))};return r.displayName="withGoogleReCaptcha("+(t.displayName||t.name||"Component")+")",oe(r,t),r};
//# sourceMappingURL=react-google-recaptcha-v3.esm.js.map


/***/ })

}]);